import { de } from "@ainkauf/core";

/**
 * Leere Liste. Statt eines grauen Kastens mit einem Satz: ein kleiner
 * gezeichneter Korb in den Farben der App. Ein leerer Bildschirm ist der
 * erste, den jemand sieht, und er soll einladen statt zu melden.
 */
export function EmptyList() {
  return (
    <div className="karte flex flex-col items-center gap-3 px-6 py-10 text-center">
      <svg width="96" height="88" viewBox="0 0 96 88" fill="none" aria-hidden className="mb-1">
        <ellipse cx="48" cy="80" rx="30" ry="5" fill="var(--paper-3)" opacity="0.7" />
        <path d="M14 30h68l-7 38a8 8 0 0 1-8 7H29a8 8 0 0 1-8-7L14 30Z" fill="var(--accent-soft)" />
        <path d="M14 30h68l-2 11H16l-2-11Z" fill="var(--accent)" opacity="0.85" />
        <path d="M33 30 41 9M63 30 55 9" stroke="var(--ink-3)" strokeWidth="3.5" strokeLinecap="round" />
        <circle cx="36" cy="55" r="7" fill="var(--food-basil)" opacity="0.9" />
        <circle cx="52" cy="60" r="9" fill="var(--food-golden)" opacity="0.9" />
        <circle cx="64" cy="52" r="6" fill="var(--food-sea)" opacity="0.9" />
      </svg>
      <p className="font-display text-xl font-extrabold tracking-tight text-ink">{de.items.empty}</p>
      <p className="text-ink-2">{de.items.emptyHint}</p>
    </div>
  );
}
